/*import { bscTokens } from "./web3/bsc-tokens";
import { bscTestnetTokens } from "./web3/bsc-testnet-tokens";
import { ethTokens } from "./web3/eth-tokens";*/

const networks = {
  ETHEREUM: "ETHEREUM",
  BSC: "BSC",
  BSC_TESTNET: "BSC_TESTNET",
};

const network = networks.BSC;

const bscConfig = {
  explorerRootURL: "https://bscscan.com/",
  rpcUrl: "https://bsc-dataseed.binance.org/",
  buyLinkPrefix: "https://exchange.pancakeswap.finance/#/swap?outputCurrency=",
  chartPrefix: "https://www.dextools.io/app/pancakeswap/pair-explorer/",
  tokens: [],
  router: "0x10ED43C718714eb63d5aA57B78B54704E256024E",
  weth: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
  //tokens: bscTokens,
};

const bscTesnetConfig = {
  explorerRootURL: "https://testnet.bscscan.com/",
  rpcUrl: "https://bsc-dataseed.binance.org/",
  buyLinkPrefix: "https://exchange.pancakeswap.finance/#/swap?outputCurrency=",
  chartPrefix: "https://www.dextools.io/app/pancakeswap/pair-explorer/",
  tokens: [],
  router: "0x10ED43C718714eb63d5aA57B78B54704E256024E",
  weth: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
  //tokens: bscTestnetTokens,
};

const ethConfig = {
  explorerRootURL: "https://etherscan.io/",
  rpcUrl: "https://bsc-dataseed.binance.org/",
  buyLinkPrefix: "https://app.uniswap.org/#/swap?use=V2&outputCurrency=",
  chartPrefix: "https://www.dextools.io/app/uniswap/pair-explorer/",
  tokens: [],
  router: "0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D",
  weth: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
  //tokens: ethTokens,
};

let networkConfig;

switch (network) {
  case networks.BSC:
  default:
    networkConfig = bscConfig;
    break;
  case networks.ETHEREUM:
    networkConfig = ethConfig;
    break;
  case networks.BSC_TESTNET:
    networkConfig = bscTesnetConfig;
    break;
}

export let globalConfig = {
  erc20ContractAbi: require("./assets/abi/ERC20.json"),
  routerAbi: require("./assets/abi/Router.json"),
  networkConfig: networkConfig,
};
